module.exports = __webpack_public_path__ + "static/assets/07a8899760bc4ec3e56cdaf941579c77.svg";